import { useState } from "react";
import { Flex, Form } from "antd";
import { CustomButton, DefaultInput } from "ui";
import { addSMSTemplate } from "services";
import { useNotificationContext } from "providers";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { parseErrorMessage, _isRequired, _isNotLongerThan } from "utils";
import { SmsTemplateType } from "interfaces/templates";

interface SMSEditModalProps {
  template: string;
  type: SmsTemplateType;
  onClose: () => void;
  onRefresh: () => void;
}

export const SMSEditModal = ({ template, type, onClose, onRefresh }: SMSEditModalProps) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { openNotification } = useNotificationContext();

  const handleSubmit = async (values: { message: string }) => {
    setLoading(true);
    try {
      await addSMSTemplate({
        message: values.message,
        type: type,
      });
      openNotification({
        message: "Шаблон успешно обновлен",
        type: NOTIFICATION_TYPE_ENUM.SUCCESS,
      });
      onRefresh();
      onClose();
    } catch (error: any) {
      openNotification({
        description: parseErrorMessage(error),
        type: NOTIFICATION_TYPE_ENUM.ERROR,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form form={form} className="full-width" onFinish={handleSubmit} initialValues={{ message: template }}>
      <Flex vertical gap="large">
        <Flex vertical>
          <Form.Item name="message" rules={[_isRequired("Поле обязательно для заполнения"), _isNotLongerThan(134)]}>
            <DefaultInput placeholder="Текст сообщения" />
          </Form.Item>
        </Flex>

        <Form.Item>
          <Flex gap="large" className="margin-top-xs">
            <CustomButton htmlType="button" className="full-width" type="default" onClick={onClose} disabled={loading}>
              Отменить
            </CustomButton>
            <CustomButton htmlType="submit" className="full-width" loading={loading}>
              Сохранить изменения
            </CustomButton>
          </Flex>
        </Form.Item>
      </Flex>
    </Form>
  );
};
